import { useSelector } from "react-redux";
import { translateComponent } from "../../utils/services/translate";
import moment from "moment";

//scss
import "./ticketConfirmationDialog.scss";
export function TicketConfirmationDialog({
  countdownValidationSeconds,
  ticket,
  isOpen,
  onClose,
  onConfirm,
}) {
  const language = useSelector((state) => state.Layout.language);
  const translations = useSelector((state) => state.Layout.translations);
  if (!isOpen) return null;

  const isButtonDisabled = () => {
    try {
      if (!ticket?.activationDate) return false;
      const activationMoment = moment(ticket.activationDate);
      if (!activationMoment.isValid()) return false;
      return activationMoment.isAfter(moment());
    } catch (error) {
      return false; // if missing date or something else goes wrong
    }
  };

  return (
    <div className="confirmation-dialog bg-white text-dark text-start h-100 pt-4">
      <div className="content-container">
        <div className="container">
          <h2>
            {translateComponent(
              translations,
              language,
              "ticket",
              "confirmDialogh2"
            )}
          </h2>
          <p>
            {" "}
            {translateComponent(
              translations,
              language,
              "ticket",
              "confirmDialogp1"
            )}
            {countdownValidationSeconds / 60}
            {translateComponent(
              translations,
              language,
              "ticket",
              "confirmDialogTimep1"
            )}
          </p>
          <p>
            {" "}
            {translateComponent(
              translations,
              language,
              "ticket",
              "confirmDialogp2"
            )}
          </p>
          {isButtonDisabled() && (
          <p className="border border-info p-2">
            {translateComponent(
              translations,
              language,
              "ticket",
              "confirmDialogText"
            )}
          </p>
           )}
        </div>
      </div>
      <div className="col-12 pe-2 ps-2 mb-3">
        <button
          className="btn btn-success w-100 mb-3"
          disabled={isButtonDisabled()}
          onClick={onConfirm}
        >
          {translateComponent(
            translations,
            language,
            "ticket",
            "confirmDialogActivateButton"
          )}
        </button>
        <button className="btn btn-danger w-100 " onClick={onClose}>
          {translateComponent(
            translations,
            language,
            "ticket",
            "confirmDialogCancelButton"
          )}
        </button>
      </div>
    </div>
  );
}
